import { Outlet } from "react-router";
import { useClient } from "@/hooks/useClient.ts";
import { version } from "@/../package.json";
import { useTranslation } from "@/i18n";

const AuthenticationLayout = () => {
  const client = useClient();
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();
  return (
    <div className="bg-background flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <div className="w-full">
          <img
            src={client!.logo_url}
            alt={client!.name}
            className="mx-auto max-h-30 rounded object-contain"
          />
        </div>
        <Outlet />
        <div className="mt-auto flex flex-col justify-center">
          <div className="text-muted-foreground text-center text-sm">
            {t("common.copyright", { year: currentYear })}
          </div>
          <div className="text-muted-foreground text-center text-xs">
            {t("common.version", { version })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthenticationLayout;
